export default "__VITE_ASSET__8e9425d4__"